import { FilterOperations } from 'business/definitions';
import { AlertFilter } from 'lib/alert/models';
import { isEmpty } from 'lodash';

/**
 * Validator that tells if the threshold filled by the user is a valid threshold,
 * which can be '+3', '-23', '2', '2.32', '-2.34'
 * @param {string} threshold - The threshold seized by the user.
 */
export const isThresholdValid = (threshold: string): boolean => {
    const numericValue = parseFloat(threshold.replace(',', '.'));

    // Check if the numeric value is valid and not NaN or infinite
    return !Number.isNaN(numericValue) && Number.isFinite(numericValue);
};

/**
 * Validator for alert filter's. It check if the filter has a value of if it has an
 * operation that does not require a value.
 * @param {AlertFilter} filter - The filter to check.
 */
export const isAlertFilterValid = (filter: AlertFilter): boolean => {
    // If the filter operation doesn't require a value, it is valid.
    if (
        filter.operation === FilterOperations.is_null ||
        filter.operation === FilterOperations.is_not_null
    ) {
        return true;
    }
    return !isEmpty(filter.value);
};
